import script from "./CalcOutputs.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcOutputs.vue?vue&type=script&setup=true&lang=js"

import "./CalcOutputs.vue?vue&type=style&index=0&id=630af593&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630af593"]])

export default __exports__